import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LanguagePersonModel, TaskResult } from '../../models/client-models';
import { AppConfig } from '../config.service';
import { HttpClient } from '@angular/common/http';

const LANGUAGE_ENDPOINT = 'language';

@Injectable({
  providedIn: 'root',
})
export class LanguageBackendService {
  constructor(private http: HttpClient) {}

  /**
   * Send request to change language to backend.
   *
   * @param newLanguage PersonID and Short language.
   */
  updateLanguage(newLanguage: LanguagePersonModel): Observable<TaskResult> {
    return this.http.post<TaskResult>(
      AppConfig.settings.backend.url + LANGUAGE_ENDPOINT,
      newLanguage
    );
  }
}
